import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { TooltipModule } from 'primeng/tooltip';
import { AlertIconModule } from '../../../components';
import { I18nModule } from '../../../i18n';
import { CplaceControlSkeletonComponent } from './cplace-control-skeleton.component';

@NgModule({
  declarations: [CplaceControlSkeletonComponent],
  imports: [CommonModule, ButtonModule, TooltipModule, I18nModule, AlertIconModule, ProgressSpinnerModule],
  exports: [CplaceControlSkeletonComponent],
})
export class CplaceControlSkeletonModule {}
